import React, { SVGProps } from "react";

const ChevronRightIcon: (
  props: React.SVGProps<SVGSVGElement>
) => JSX.Element = ({
  height = "24px",
  width = "24px",
  stroke = "black",
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={height}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 5L16 12L9 19"
        stroke={stroke}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronRightIcon;
